import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    backButton: {
        // marginRight: theme.spacing.unit,
    },
}));

function getStepContent(stepIndex, steps) {
    if (steps[stepIndex]) {
        return steps[stepIndex].component;
    } else {
        return null;
    }
}

const FormStepper = ({ steps, activeStep, onNavigateBack, onNavigateNext, onFinish }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} alternativeLabel>
                {
                    steps.map(({ label }) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))
                }
            </Stepper>
            <div>
                <div>
                    <div className={classes.instructions}>{getStepContent(activeStep, steps)}</div>
                    <div className="row">
                        <div className="col">
                            <div className="float-left">
                                {
                                    activeStep !== 0 &&
                                    <Button
                                        variant="contained"
                                        onClick={onNavigateBack}
                                        className={classes.backButton}
                                    >
                                        Back
                                    </Button>
                                }
                            </div>
                            <div className="float-right">
                                {
                                    activeStep === steps.length - 1 ?
                                        <Button variant="contained" color="primary" onClick={onFinish}>
                                            Submit
                                        </Button>
                                        :
                                        <Button variant="contained" color="primary" onClick={onNavigateNext}>
                                            Next
                                         </Button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FormStepper;
